module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-minus-fill-853d59a7.svg";